<section id="account-statements" data-cy="statements-screen">
  <ion-modal class="datetime-modal" trigger="open-dateFrom">
    <ng-template>
      <ion-content>
        <!-- [isDateEnabled]="isDateEnabledFrom" -->
        <ion-datetime
          id="datetimeFrom"
          [showDefaultButtons]="true"
          (ionChange)="setDate($event, 'dateFrom')"
          [value]="formVal['dateFrom'].value"
          data-cy="date-from-calendar"
          class="!tw-h-full"
        ></ion-datetime>
      </ion-content>
    </ng-template>
  </ion-modal>

  <ion-modal class="datetime-modal" trigger="open-dateTo">
    <ng-template>
      <ion-content>
        <!-- [isDateEnabled]="isDateEnabledTo" -->
        <ion-datetime
          id="datetimeTo"
          [showDefaultButtons]="true"
          (ionChange)="setDate($event, 'dateTo')"
          [value]="formVal['dateTo'].value"
          data-cy="date-to-calendar"
          class="!tw-h-full"
        ></ion-datetime>
      </ion-content>
    </ng-template>
  </ion-modal>

  <!-- <input type="datetime-local" id="birthdaytime" name="birthdaytime"> -->


  <form [formGroup]="getStatementsForm">
    <div class="tw-flex tw-flex-col">
      <span class="label tw-text-[16px] tw-w-full" data-cy="date-from-txt">Date From</span>

      <!-- formControlName="dateFrom" -->
      <ion-input
        mode="md"
        [value]="formVal['dateFrom'].value | statement: 'formatDate'"
        type="button"
        id="open-dateFrom"
        class="tw-w-full tw-h-[38px] !tw-min-h-[38px] !tw-mb-[16px]"
        data-cy="date-from-input"
      ></ion-input>
      <img
        src="/assets/images/account_settings/calendar.png"
        class="dateFrom"
        data-cy="date-from-cal"
      >
    </div>

    <div class="tw-flex tw-flex-col">
      <span class="label tw-text-[16px] tw-w-full" data-cy="date-to-txt">Date To</span>

      <!-- formControlName="dateTo" -->
      <ion-input
        mode="md"
        [value]="formVal['dateTo'].value | statement: 'formatDate'"
        type="button"
        id="open-dateTo"
        class="tw-w-full tw-h-[38px] !tw-min-h-[38px] !tw-mb-[16px]"
        data-cy="date-to-input"
      ></ion-input>
      <img
        src="/assets/images/account_settings/calendar.png"
        class="dateTo"
        data-cy="date-to-cal"
      >
    </div>

    <div class="tw-flex tw-flex-col">
      <span class="label tw-text-[16px] tw-w-full" data-cy="track-txt">Track</span>
      <ion-select
        formControlName="track"
        label-placement="stacked"
        interface="popover"
        toggleIcon="chevron-down-outline"
        expandedIcon="chevron-up-outline"
        class="tw-h-[38px] !tw-min-h-[38px] !tw-mb-[16px] !tw-rounded-[4px]"
        data-cy="track-dropdown"
      >
        <ion-icon
          *ngIf="formVal['track']?.value"
          slot="end"
          name="close"
          aria-hidden="true"
          class="tw-ml-[2px] tw-mr-[6px]"
          (click)="formVal['track']?.setValue('')"
          data-cy="track-x-icon"
        ></ion-icon>

        <ion-select-option
          [value]="track"
          *ngFor="let track of tracks; trackBy: trackByFn"
        >
          <span>{{ track?.EventName }}</span>
        </ion-select-option>
      </ion-select>
    </div>

    <div class="tw-flex tw-flex-col">
      <span class="label tw-text-[16px] tw-w-full" data-cy="pool-txt">Pool</span>
      <ion-select
        formControlName="pool"
        label-placement="stacked"
        interface="popover"
        toggleIcon="chevron-down-outline"
        expandedIcon="chevron-up-outline"
        class="tw-h-[38px] !tw-min-h-[38px] !tw-mb-[16px]"
        data-cy="pool-dropdown"
      >
        <ion-icon
          *ngIf="formVal['pool']?.value"
          slot="end"
          name="close"
          aria-hidden="true"
          class="tw-ml-[2px] tw-mr-[6px]"
          (click)="formVal['pool']?.setValue('')"
        ></ion-icon>

        <ion-select-option
          [value]="poolId"
          *ngFor="let poolId of POOL_LIST_ID; trackBy: trackByFn"
        >
          <span>{{ poolId }}</span>
        </ion-select-option>
      </ion-select>
    </div>


    <button
      (click)="searchStatements()"
      [ngClass]="{'active': getStatementsForm.valid}"
      [disabled]="getStatementsForm.invalid"
      class="search-statements tw-w-full tw-h-[41px] tw-text-[16px] tw-mt-[10px] tw-mb-[10px]"
      data-cy="search-btn"
    >
      Search
    </button>
  </form>

  <!-- Totals -->
  <div class="tw-flex tw-flex-row tw-w-full tw-mt-[30px] totals">
    <div class="tw-flex tw-flex-col tw-w-6/12 total-label">
      <div><span class="tw-py-[2px]" data-cy="total-deposit-txt">Total Deposit:</span></div>
      <div><span class="tw-py-[2px]" data-cy="total-withdraw-txt">Total Withdraw:</span></div>
      <div><span class="tw-py-[2px]" data-cy="total-bet-txt">Total Bet:</span></div>
      <div><span class="tw-py-[2px]" data-cy="total-won-txt">Total Won:</span></div>
      <div><span class="tw-py-[2px]" data-cy="total-pl-txt">Total Profit/Loss:</span></div>
    </div>
    <div class="tw-flex tw-flex-col tw-w-6/12 total-value">
      <div>
        <span class="tw-py-[2px]" data-cy="statements-total-deposit">
          {{
            (statements?.response?.Totals?.TotalDeposit|numberWithCommas) === '0'
              ? '$0.00'
              : '$' + (statements?.response?.Totals?.TotalDeposit|numberWithCommas)
          }}
        </span>
      </div>
      <div>
        <span class="tw-py-[2px]" data-cy="statements-total-withdrawal">
          {{
            (statements?.response?.Totals?.TotalWithdrawal|numberWithCommas) === '0'
              ? '$0.00'
              : '$' + (statements?.response?.Totals?.TotalWithdrawal|numberWithCommas)
          }}
        </span>
      </div>
      <div>
        <span class="tw-py-[2px]" data-cy="statements-total-bet">
          {{
            (statements?.response?.Totals?.TotalBet|numberWithCommas) === '0'
              ? '$0.00'
              : '$' + (statements?.response?.Totals?.TotalBet|numberWithCommas)
          }}
        </span>
      </div>
      <div>
        <span class="tw-py-[2px]" data-cy="statements-total-won">
          {{
            (statements?.response?.Totals?.TotalWon|numberWithCommas) === '0'
              ? '$0.00'
              : '$' + (statements?.response?.Totals?.TotalWon|numberWithCommas)
          }}
        </span>
      </div>
      <div>
        <span class="tw-py-[2px]" data-cy="statements-total-pl">
          {{
            statements?.response?.Totals?.TotalBet && statements?.response?.Totals?.TotalWon
              ? (statements?.response?.Totals?.TotalBet && statements?.response?.Totals?.TotalWon === 0)
                ? '$0.00'
                : '$' + ((statements?.response?.Totals?.TotalWon||0) - (statements?.response?.Totals?.TotalBet||0) | numberWithCommas)
              : '$0.00'
          }}
        </span>
      </div>
    </div>
  </div>

  <!-- Results -->
  <div class="tw-mt-[20px] results">
    <div *ngIf="statements?.response?.AccountReport?.length !== 0">
      <div *ngFor="let item of statements?.response?.AccountReport; let i = index" class="result-item tw-flex tw-flex-row tw-w-full tw-mb-[10px]">
        <div class="tw-flex tw-flex-col tw-w-6/12 tw-pr-[6px]">
          <div [attr.data-cy]="'item-date-' + i"><span>Date: {{ item | statement: 'date' }}</span></div>
          <div [attr.data-cy]="'item-event-' + i"><span>EventName: {{ item?.EventName | titlecase }}</span></div>
          <div [attr.data-cy]="'item-amount-' + i">
            <span>
              Amount: {{
                ((item?.TicketAmount | numberWithCommas) === '0')
                  ? '$0.00'
                  : '$' + (item?.TicketAmount | numberWithCommas)
              }}
            </span>
          </div>
          <div [attr.data-cy]="'item-runners-' + i"><span>Runners: {{ item?.Runners }}</span></div>
          <div [attr.data-cy]="'item-credit-' + i"><span>Credit: {{ item | statement: 'credit' }}</span></div>
        </div>
        <div class="tw-flex tw-flex-col tw-w-6/12">
          <div [attr.data-cy]="'item-status-' + i"><span>Status: {{ item | statement: 'status' | titlecase }}</span></div>
          <div [attr.data-cy]="'item-race-' + i"><span>Race: {{ item?.RaceId }}</span></div>
          <div [attr.data-cy]="'item-pool-' + i"><span>Pool: {{ item | statement: 'pool' }}</span></div>
          <div [attr.data-cy]="'item-debit-' + i"><span>Debit: {{ item | statement: 'debit' }}</span></div>
          <div [attr.data-cy]="'item-pl-' + i"><span>P/L: {{ item | statement: 'pl' }}</span></div>
        </div>
      </div>
    </div>

    <div *ngIf="statements?.response?.AccountReport?.length === 0">
      <span data-cy="statement_no_records">No Records Found</span>
    </div>

  </div>

</section>
